import { render, staticRenderFns } from "./UserCheckJourney.vue?vue&type=template&id=53917660&scoped=true&"
import script from "./UserCheckJourney.vue?vue&type=script&lang=js&"
export * from "./UserCheckJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53917660",
  null
  
)

export default component.exports